/**
 * Region names come from `countries.json` as English data values ("Middle
 * East", "Latin America").  Rendering them raw leaked English onto every
 * Russian country card.  Map the data value to an i18n key; unknown values
 * fall back to the raw string so a newly added region degrades to English
 * instead of an empty badge.
 */

const REGION_KEYS: Record<string, string> = {
  Africa: 'africa',
  Americas: 'americas',
  Asia: 'asia',
  Caribbean: 'caribbean',
  Caucasus: 'caucasus',
  Europe: 'europe',
  'Indian Ocean': 'indianOcean',
  'Latin America': 'latam',
  'Middle East': 'middleEast',
  'South America': 'southAmerica',
  'Southeast Asia': 'southeastAsia',
};

type TFn = (key: string, opts?: Record<string, unknown>) => string;

export function regionLabel(region: string | undefined | null, t: TFn): string {
  if (!region) return '';
  const key = REGION_KEYS[region];
  if (!key) return region;
  return t(`countries.regionName.${key}`, { defaultValue: region });
}
